import {Pipe, PipeTransform} from '@angular/core';
import {Util} from "../../app/util";

/**
 * Generated class for the DatetimePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'datetime',
})
export class DatetimePipe implements PipeTransform {

    constructor(public util: Util) {


    }

    transform(value: string, dia: null | 'dd' = 'dd', mes: null | 'num' | 'char' | 'full' = 'char', ano: null | 'yy' | 'yyyy' = 'yyyy', separa: '/' | ' ' = ' ') { // ...args -> quando aceita infinitos argumentos?

        return this.util.dataft(value, dia, mes, ano, separa);

    }

}



// WEBPACK FOOTER //
// ./src/pipes/datetime/datetime.ts